import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useEffect, useState } from 'react';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { PaymentTaskEditForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskEditForm';

export const PaymentTaskEdit = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { paymentTask: task } = useCurrentPaymentTask();
  useEffect(() => setTitle(`支払タスク編集`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
        {
          label: `プロジェクト（費用）詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`,
        },
        {
          label: `支払タスク詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}/payment_tasks/${task!.id}`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PaymentTaskEditForm />
    </WorkspaceLayout>
  );
};
